<template src="./index.html"></template>
<script>
import Retrieve from './Retrieve/index.vue';
import { login,verifyCode,sysindex } from '../../../api/home.js';
// import { hex_md5 } from '../../../../md5.js';
import configHttp from '../../../../configHttp.js';
export default {
	components: {
		Retrieve
	},
	data() {
		return {
			input4: '',
			show_code: false,
			Vcode_content: '获取验证码',
			Vpassword: true,
			formLabelAlign: {
				name: '',
				region: '',
				type: ''
			},
			loginformrules: {
				name: [
					{
						required: true,
						message: '请输入用户名',
						trigger: 'blur'
					}
				],
				region: [
					{
						required: true,
						message: '密码未填写，请填写完整',
						trigger: 'blur'
					}
				],
				type: [
					{
						required: true,
						message: '验证码未填写，请填写完整',
						trigger: 'blur'
					}
				]
			},
			showpassword: false,
			src_img: require('../../../assets/img/nobey.svg'),
			picture:"",
			uuid:""
		};
	},
	created() {
		this.verification();
	},
	mounted() {},
	methods: {
		verification() {
			verifyCode().then(res => {
				if (res.data.code == '200') {
					this.picture = res.data.data.img;
					this.uuid = res.data.data.uuid;
					this.$forceUpdate();
				}
			});
		},
		input_icon_img() {
			this.showpassword = !this.showpassword;
			if (this.src_img == require('../../../assets/img/nobey.svg')) {
				this.src_img = require('../../../assets/img/yesbey.svg');
			} else {
				this.src_img = require('../../../assets/img/nobey.svg');
			}
		},

		show_password() {
			this.Vpassword = true;
		},
		forlogin() {
			this.$refs['formLabelAlign'].validate(valid => {
				if (valid) {
					let params = {
						userName: this.formLabelAlign.name,
						password: this.formLabelAlign.region,
						code: this.formLabelAlign.type,
						uuid: this.uuid
					};
					login(params).then(res => {
						console.log(res.data);
						if (res.data.code=='200') {
							localStorage.setItem('token', res.data.data);
							this.$router.push({
								path: '/Homepage'
							});
						} else {
							this.$message.error(res.data.message);
						}
					});
				}
			});
		},
		// //验证码
		verificationCode() {
			if (!this.show_code) {
				this.show_code = true;
				let num = 60;
				this.Vcode_content = num + 's';
				let time = setInterval(() => {
					if (num > 1) {
						num--;
						this.Vcode_content = num + 's';
					} else {
						this.Vcode_content = '获取验证码';
						this.show_code = false;
						clearInterval(time);
					}
				}, 1000);
			}
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
